module.exports = __webpack_public_path__ + "account/assets/additional.6f4f2973.svg";